<template>
  <div class="flex w-full p-4 rounded-xl">
    <div class="flex flex-col items-center h-full text-13 w-full font-semibold">
      <p class="flex text-primary-100 text-lg font-semibold leading-26 items-center self-stretch">Piyasalar & Döviz</p>
      <div v-for="currency in currencyList" :key="currency.name" :title="currency.name" class="flex flex-col items-center w-full">
        <div class="border-t border-[#000]/[.1] w-full my-4"></div>
        <div class="flex justify-between w-full">
          <span class="flex items-center">
            <OIcon :icon="currencyIcon(currency)" class="mr-2" />
            <p class="w-[60px] text-md font-semibold leading-22 text-primary-100">{{ currency.name }}</p>
          </span>
          <span class="flex items-center w-[70px] text-sm font-semibold leading-22 text-right text-primary-100">
            {{ currency.sellingRate }}
          </span>
          <span class="flex items-center justify-end">
            <OIcon :icon="statusIcon(currency)" svg-class=" mr-1" />
            <span :class="statusColor(currency)" class="u-center w-[45px] font-medium text-white px-1 rounded-sm">
              {{ currency.changeIndicatorCN }}%
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed, onMounted, onUnmounted, ssrRef, useContext } from '@nuxtjs/composition-api';
import Swiper from '@/modules/sliders/core/Swiper';
import { Autoplay } from 'swiper';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import { cloneDeep } from 'lodash';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import { useWebSocket } from '~/composables/useWebSocket';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  props: {
    currencies: {
      type: Array,
    },
  },
  components: { Swiper, SwiperSlide, OIcon },
  setup(props) {
    const { isMobile } = useDevice();
    const { user } = useAuth();
    const { $oet } = useContext();
    const { Init, Subscribe, Unsubscribe, GetTopicIds } = useWebSocket();
    const settings = computed(() => ({
      speed: 150,
      autoplay: {
        delay: 3000,
      },
      slidesPerView: 'auto',
    }));
    const currencyIcon = (currency) => `currency/${currency.icon}`;
    const statusIcon = (currency) => `currency/${currency.changeIndicatorCN > 0 ? 'up' : 'down'}`;
    const statusColor = (currency) => (currency.changeIndicatorCN > 0 ? 'bg-o-green' : 'bg-o-red');
    const statusColorMobile = (currency) => (currency.changeIndicatorCN > 0 ? 'bg-o-green' : 'bg-o-red');
    const currencyList = ssrRef(props.currencies);

    // websocket callback
    const updateCurrencies = (currency) => {
      const _currencies = cloneDeep(currencyList.value);
      const index = _currencies.findIndex((item) => item.name === currency.value.name);
      if (index < 0) return;
      _currencies[index] = currency.value;
      currencyList.value = _currencies;
    };

    const clientIdChangeCallbackFn = async (clientOldId, clientNewId) => {
      if (clientOldId !== clientNewId) {
        await $oet.sendPushNotificationPlatformInformations({
          userId: user.value?._id,
          notificationTargetValue: clientNewId,
          externalPlatform: 'chatty',
          notificationTargetType: 'chattyId',
        });
      }
    };

    onMounted(async () => {
      const topicIds = await GetTopicIds('exchangeRates');
      await Init({ forceInit: true, cidChangeCallback: clientIdChangeCallbackFn });
      Subscribe({ topicIds, callback: updateCurrencies });
    });

    onUnmounted(async () => {
      const topicIds = await GetTopicIds('exchangeRates');
      Unsubscribe({ topicIds });
    });
    return { Autoplay, settings, isMobile, currencyIcon, statusIcon, statusColor, statusColorMobile, currencyList };
  },
});
</script>

<style lang="scss">
.currencySlider {
  .swiper-slide {
    width: auto !important;
  }
}
</style>
